import { useEffect, useState } from "react";
import { CardDetails } from "../../../../common/components/CardDetails/CardDetails"
import style from "./style.module.scss"
import { VehicleService } from "../../../../common/services/merchandise_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../common/components/Loader/Loader";

type storageVehicleDetailType = {
  initialValue: any
}

const StorageVehicleDetail = ( {initialValue}: storageVehicleDetailType) => {

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>({});

  const id = initialValue?.["@id"].split("/").pop();

  useEffect(() => {
    id && getStorageVehicle(id);
  }, [initialValue]);

  const getStorageVehicle = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await VehicleService.getVehicleById(id);
      if (res?.status === HttpStatusCode.Ok) {
        setData(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

const renderValue = (value : any /* string | number | boolean */) => {
  return value ? value : "-";
}; 

  return (
    <div>
      <Loader isLoading={isLoading}/>
      <CardDetails className="d-flex gap-2 flex-column">
              <div className={style.details__item}>
                <span className={style.details__subtitle}>N° : </span>
                <span className={style.details__value}>{renderValue(data?.registrationNumber)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Marque : </span>
                <span className={style.details__value}>{renderValue(data?.brand)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Modèle : </span>
                <span className={style.details__value}>{renderValue(data?.model)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Année : </span>
                <span className={style.details__value}>{renderValue(data?.year)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Numéro de série : </span>
                <span className={style.details__value}>{renderValue(data?.serialNumber)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Niveau du carburant : </span>
                <span className={style.details__value}>{renderValue(data?.fuelLevel)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Type de carburant : </span>
                <span className={style.details__value}>{renderValue(data?.fuelType)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Tonnage (T) : </span>
                <span className={style.details__value}>{renderValue(data?.tonnage)}</span>
              </div>
            </CardDetails>
    </div>
  )
}

export default StorageVehicleDetail